import { Card, CardContent } from "@/components/ui/card";
import { MessageSquare, Calculator, BookOpen, FileText, Database, Lightbulb } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    icon: MessageSquare,
    title: "AI Engineering Assistant",
    description: "24/7 AI support for HVAC, electrical, firefighting, and plumbing queries. Get instant answers with code references.",
  },
  {
    icon: Calculator,
    title: "Smart Calculations",
    description: "Automated engineering calculations with formula validation, code compliance, and exportable reports.",
  },
  {
    icon: BookOpen,
    title: "Codes & Standards Library",
    description: "Searchable database of ASHRAE, NFPA, NEC, IEC, and international engineering standards.",
  },
  {
    icon: Database,
    title: "Real Project Database",
    description: "Access shop drawings, photos, and technical details from real MEP projects across industries.",
  },
  {
    icon: FileText,
    title: "Content Generator",
    description: "Auto-generate method statements, submittals, RFIs, technical reports, and LinkedIn posts.",
  },
  {
    icon: Lightbulb,
    title: "Design Validation",
    description: "Validate your designs against international codes with instant feedback and recommendations.",
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="border-b border-border/40 bg-muted/30 py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <motion.h2 
            className="mb-4 text-3xl font-bold md:text-4xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Everything You Need for MEP Engineering
          </motion.h2>
          <motion.p 
            className="text-lg text-muted-foreground"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            From design to commissioning, we've got you covered
          </motion.p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full border-border/40 bg-card/50 backdrop-blur transition-all hover:border-primary/30 hover:shadow-lg">
                <CardContent className="p-6">
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                    <feature.icon className="h-6 w-6 text-primary" />
                  </div>
                  <h3 className="mb-2 text-xl font-semibold">{feature.title}</h3>
                  <p className="text-muted-foreground">{feature.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
